import { render, staticRenderFns } from "./EditSubscriptionPlanButton.vue?vue&type=template&id=2653eda4&"
import script from "./EditSubscriptionPlanButton.vue?vue&type=script&lang=js&"
export * from "./EditSubscriptionPlanButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports